module.exports = __webpack_public_path__ + "static/media/bowen-44.4978c6a0.jpg";